import React from 'react'
import { Box, Typography } from '@mui/material'
import SearchIcon from '../../../assets/search.svg'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import AddIcon from '@mui/icons-material/Add'
import { ImageWrapper, Wrapper } from './styles'
import { blue, grey } from '../../../colors'
import { type Row, type INoDataComponentProps } from '../types'
import { PermissionEnum, type DataObjectList } from '../../../models/DataObject'
import { useTheme } from '@mui/material/styles'

interface NoDataFoundProps {
  noDataComponentProps?: INoDataComponentProps
  list?: DataObjectList<Row> | null
  searchText: string | null
  hasActiveFilters?: boolean
}

const NoDataFound: React.FC<NoDataFoundProps> = ({ searchText, noDataComponentProps, list, hasActiveFilters = false }) => {
  const { title, subTitle, icon } = noDataComponentProps ?? {}
  const isCreatePermission = list?.permissions?.includes(PermissionEnum.CREATE)
  const theme = useTheme()

  const filtersAndSearchContent = (): JSX.Element => (
    <>
      <ImageWrapper>
        <img src={SearchIcon} alt="Search Icon" />
      </ImageWrapper>
      <Box>
        <Typography fontWeight='bold' textAlign='center'>No results</Typography>
        <Typography textAlign='center' color={grey[650]} fontSize='14px' lineHeight={theme.spacing(6)}>
          Please try again.
        </Typography>
      </Box>
    </>
  )

  const defaultContent = (): JSX.Element => (
    <>
      <ImageWrapper>
        <InfoOutlinedIcon sx={{ color: blue[500] }} />
      </ImageWrapper>
      <Box>
        <Typography fontWeight='bold'>Nothing to show here</Typography>
      </Box>
    </>
  )

  const customContent = (): JSX.Element => (
    <>
     <ImageWrapper>
        {icon ?? <AddIcon />}
      </ImageWrapper>
      <Box>
        <Typography textAlign='center' fontWeight='bold'>{title}</Typography>
        <Typography textAlign='center' color={grey[650]} fontSize='14px' lineHeight={theme.spacing(6)}>
          {subTitle}
        </Typography>
      </Box>
    </>
  )

  const getContent = (searchText: string | null, noDataComponentProps: INoDataComponentProps | undefined, isCreatePermission: boolean | undefined): JSX.Element => {
    switch (true) {
      case !!searchText || hasActiveFilters:
        return filtersAndSearchContent()
      case noDataComponentProps == null || !isCreatePermission:
        return defaultContent()
      case isCreatePermission && noDataComponentProps != null:
        return customContent()
      default:
        return <div></div>
    }
  }

  return (
    <Wrapper>
      <Box maxWidth={theme.spacing(88)} display='flex' justifyContent='center' alignItems='center' flexDirection='column' gap={theme.spacing(1)}>
        {
          getContent(searchText, noDataComponentProps, isCreatePermission)
        }
      </Box>
    </Wrapper>
  )
}

export default NoDataFound
